import React from "react";
import { usePage } from "../../context/PageContext";
import BlockWrapper from "./BlockWrapper";

import { DndContext, closestCenter } from "@dnd-kit/core";
import {
  SortableContext,
  verticalListSortingStrategy,
  arrayMove,
} from "@dnd-kit/sortable";

const Canvas = () => {
  const { blocks, setBlocks, addBlock, mode, setMode } = usePage();

  const handleDragEnd = (event) => {
    if (mode !== "edit") return;

    const { active, over } = event;
    if (!over) return;

    if (active.id !== over.id) {
      const oldIndex = blocks.findIndex((b) => b.id === active.id);
      const newIndex = blocks.findIndex((b) => b.id === over.id);
      setBlocks(arrayMove(blocks, oldIndex, newIndex));
    }
  };

  const isPreview = mode === "preview";

  return (
    <div
      onDragOver={(e) => e.preventDefault()}
      onDrop={(e) => {
        const type = e.dataTransfer.getData("blockType");
        if (type) addBlock(type);
      }}
    >
      <header className="canvas-header">
        <div>
          <h1 className="canvas-title">Your page</h1>
          <p className="canvas-subtitle">
            Drag blocks from the sidebar or tap to insert. Reorder with the
            handle in edit mode.
          </p>
        </div>
        <button
          type="button"
          className={`mode-toggle${isPreview ? " is-preview" : ""}`}
          onClick={() => setMode(isPreview ? "edit" : "preview")}
        >
          {isPreview ? "Edit layout" : "Preview"}
        </button>
      </header>

      <DndContext collisionDetection={closestCenter} onDragEnd={handleDragEnd}>
        <SortableContext
          items={blocks.map((b) => b.id)}
          strategy={verticalListSortingStrategy}
        >
          {blocks.map((block) => (
            <BlockWrapper key={block.id} block={block} />
          ))}
        </SortableContext>
      </DndContext>

      {blocks.length === 0 && (
        <div className="canvas-empty">
          <p>
            Drag a block here or click one in the sidebar to start building.
          </p>
        </div>
      )}
    </div>
  );
};

export default Canvas;
